import React from 'react';

import {Helmet} from 'views/module';

import BulkMessagingScene from 'views/scenes/bulk_messaging/BulkMessaging';

const BulkMessaging = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Bulk Messaging</title>
      </Helmet>
      <BulkMessagingScene />
    </>
  );
};

export default React.memo(BulkMessaging);
